(function () {
  if (document.documentElement.dataset.wldPcQuickAddBound) return;
  document.documentElement.dataset.wldPcQuickAddBound = '1';

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;

      var sizeBtn = t.closest('[data-wld-pc-size]');
      if (sizeBtn && !sizeBtn.disabled && sizeBtn.closest('[data-wld-pc-quick]')) {
        var wrap = sizeBtn.closest('[data-wld-pc-quick]');
        if (!wrap) return;
        wrap.classList.add('pc-quick--size-chosen');
        wrap.querySelectorAll('[data-wld-pc-size]').forEach(function (b) {
          var on = b === sizeBtn;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        var vid = sizeBtn.getAttribute('data-variant-id');
        var atc = wrap.querySelector('[data-wld-pc-quick-atc]');
        if (atc && vid) {
          atc.setAttribute('data-variant-id', vid);
          atc.disabled = false;
        }
        return;
      }

      var atcBtn = t.closest('[data-wld-pc-quick-atc]');
      if (!atcBtn || atcBtn.disabled) return;
      var variantId = atcBtn.getAttribute('data-variant-id');
      if (!variantId) return;
      e.preventDefault();
      e.stopPropagation();
      atcBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) {
            return r
              .json()
              .catch(function () {
                return {};
              })
              .then(function (body) {
                throw body;
              });
          }
          return r.json();
        })
        .then(function () {
          return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(
            function (r) {
              return r.json();
            }
          );
        })
        .then(function (cart) {
          var n = typeof cart.item_count === 'number' ? cart.item_count : 0;
          try {
            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: cart,
                  data: {
                    itemCount: n,
                    source: 'wld-product-card-quick-add'
                  }
                }
              })
            );
          } catch (err) {}
        })
        .catch(function () {})
        .finally(function () {
          atcBtn.disabled = false;
        });
    },
    false
  );
})();
